/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef, useEffect, RefObject } from 'react';
import { ClickOutsideDetectorTypes } from './types';

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(
  ref: RefObject<HTMLDivElement | null>,
  setOptionsListVisible: (state: boolean) => void,
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
        // alert('You clicked outside of me!');
        setOptionsListVisible(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, setOptionsListVisible]);
}

/**
 * Component that alerts if you click outside of it
 */

export default function ClickOutsideDetector({
  children,
  className = '',
  setOptionsListVisible,
  onMouseEnter,
  onMouseLeave,
  onMouseUp,
  onContextMenu,
  onKeyUp,
}: ClickOutsideDetectorTypes): React.JSX.Element {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOptionsListVisible);

  return (
    <div
      ref={wrapperRef}
      className={className}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      onMouseUp={onMouseUp}
      onContextMenu={onContextMenu}
      onKeyUp={onKeyUp}
    >
      {children}
    </div>
  );
}
